import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import { MediaParallaxCardsCardDto } from '@/components/service-pages/MediaParallaxCards/types';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import css from './style.module.scss';
interface Props {
  className?: string;
  theme?: 'purple' | 'green';
  data: MediaParallaxCardsCardDto;
  isIndustry: boolean;
}
const Card: FC<Props> = t0 => {
  const $ = _c(33);
  const {
    className,
    data,
    theme: t1,
    isIndustry
  } = t0;
  const theme = t1 === undefined ? "purple" : t1;
  const {
    number,
    title,
    text,
    author,
    linkUrl
  } = data;
  const hasNumber = Boolean(number);
  const t2 = hasNumber && css.numbered;
  const t3 = theme === "green" && css.greenTheme;
  let t4;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3) {
    t4 = clsx(css.card, t2, t3, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const classNames = t4;
  const t5 = isIndustry ? "body-m" : "body-l";
  let t6;
  if ($[4] !== number || $[5] !== t5) {
    t6 = <Typography uppercase={true} variant={t5} tag="span" className={css.number}>{number}</Typography>;
    $[4] = number;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isIndustry || $[8] !== title) {
    t7 = title ? <Typography uppercase={true} className={css.title} variant={isIndustry ? "h3-industry" : "h5"} tag="h3">{typeof title === "string" ? title : <StrapiRichContent content={title} />}</Typography> : null;
    $[7] = isIndustry;
    $[8] = title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={css.divider} />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== text) {
    t9 = <Typography className={css.text} variant="body-m" tag="p">{text}</Typography>;
    $[11] = text;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== t9) {
    t10 = <>{t6}{t7}{t8}{t9}</>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const innerNumbered = t10;
  let t11;
  if ($[17] !== isIndustry || $[18] !== title) {
    t11 = title ? <Typography uppercase={true} className={css.title} variant={isIndustry ? "h3-industry" : "h5"} tag="h3">{typeof title === "string" ? title : <StrapiRichContent content={title} />}</Typography> : null;
    $[17] = isIndustry;
    $[18] = title;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = isIndustry ? "body-m" : "body-l";
  let t13;
  if ($[20] !== t12 || $[21] !== text) {
    t13 = <Typography className={css.text} variant={t12} tag="p">{text}</Typography>;
    $[20] = t12;
    $[21] = text;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== author) {
    t14 = author ? <Typography className={css.author} variant="body-m" tag="p">{author}</Typography> : null;
    $[23] = author;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t13 || $[27] !== t14) {
    t15 = <>{t11}{t13}{t14}</>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const innerPlain = t15;
  const inner = hasNumber ? innerNumbered : innerPlain;
  let t16;
  if ($[29] !== classNames || $[30] !== inner || $[31] !== linkUrl) {
    t16 = linkUrl ? <a className={classNames} href={linkUrl} target="_blank" rel="noopener noreferrer">{inner}</a> : <div className={classNames}>{inner}</div>;
    $[29] = classNames;
    $[30] = inner;
    $[31] = linkUrl;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};
export default Card;